import React from 'react';

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');

const Avatar = ({ r, size, border }) => (
  <div className={`${size} mb-1 shrink-0 overflow-hidden rounded-full border-2 ${border} bg-purple-900 shadow-lg`}>
    {r.avatar ? <img src={r.avatar} alt="" className="h-full w-full object-cover" data-testid={`rp-top-avatar-${r.pos}`} />
      : <div className="flex h-full w-full items-center justify-center text-sm font-black text-purple-100">{(r.nickname || '?')[0]}</div>}
  </div>
);

const Podio = ({ r, size, border, nameCls, barCls, barH, medal }) => (
  <div className={`flex flex-1 flex-col items-center ${size.max}`} data-testid={`rp-top-row-${r.pos}`}>
    <Avatar r={r} size={size.av} border={border} />
    <p className={`w-full truncate text-center text-[10px] font-bold ${nameCls}`}>{r.nickname}</p>
    <p className="text-[9px] text-fuchsia-300/80">({r.kako_masked}){r.me && <span className="ml-1 font-black text-lime-300">VOCÊ</span>}</p>
    <p className="text-[10px] font-black text-amber-300" data-testid={`rp-top-coins-${r.pos}`}>🪙{fmt(r.coins)}</p>
    <p className="text-[9px] text-purple-200/70">{r.chests} baú(s)</p>
    <div className={`mt-1 flex w-full items-center justify-center rounded-t-lg ${barCls} ${barH}`}><span className="text-2xl">{medal}</span></div>
  </div>
);

// Top 10 Sortudos — pódio TOP 3 + lista com scroll (mesmo padrão do ranking da Roleta). Tudo vindo do servidor.
export const RpTopWinners = ({ top }) => {
  const rank = top || [];
  const rest = rank.slice(3);
  return (
    <div data-testid="rp-top">
      {rank.length === 0 && <p className="py-4 text-center text-[11px] text-purple-200/70" data-testid="rp-top-empty">Ninguém abriu um baú ainda — seja o primeiro! 🏆</p>}
      {rank.length > 0 && (
        <div className="flex items-end justify-center gap-2 py-2" data-testid="rp-top-podium">
          {rank[1] && <Podio r={rank[1]} size={{ max: 'max-w-[90px]', av: 'h-10 w-10' }} border="border-slate-300" nameCls="text-slate-200" barCls="bg-gradient-to-t from-slate-600 to-slate-400" barH="h-14" medal="🥈" />}
          {rank[0] && <Podio r={rank[0]} size={{ max: 'max-w-[100px]', av: 'h-12 w-12' }} border="border-amber-300" nameCls="text-amber-200" barCls="bg-gradient-to-t from-amber-600 to-amber-300 shadow-lg shadow-amber-500/30" barH="h-20" medal="🥇" />}
          {rank[2] && <Podio r={rank[2]} size={{ max: 'max-w-[80px]', av: 'h-9 w-9' }} border="border-orange-500" nameCls="text-orange-300" barCls="bg-gradient-to-t from-orange-800 to-orange-500" barH="h-10" medal="🥉" />}
        </div>
      )}
      {rest.length > 0 && (
        <ul className="custom-scrollbar mt-2 max-h-52 space-y-1.5 overflow-y-auto border-t border-fuchsia-500/30 pr-1 pt-2" data-testid="rp-top-list">
          {rest.map((r) => (
            <li key={r.pos} data-testid={`rp-top-row-${r.pos}`}
              className={`flex items-center gap-2 rounded-lg border px-2.5 py-1.5 ${r.me ? 'border-lime-400/70 bg-lime-500/10' : 'border-white/10 bg-white/5'}`}>
              <span className="w-6 shrink-0 text-center text-xs font-bold text-fuchsia-300">{r.pos}º</span>
              <div className="h-7 w-7 shrink-0 overflow-hidden rounded-full border border-fuchsia-500/50 bg-purple-900">
                {r.avatar ? <img src={r.avatar} alt="" className="h-full w-full object-cover" data-testid={`rp-top-avatar-${r.pos}`} />
                  : <div className="flex h-full w-full items-center justify-center text-[10px] font-black">{(r.nickname || '?')[0]}</div>}
              </div>
              <p className="min-w-0 flex-1 truncate text-xs text-white">{r.nickname} <span className="text-[10px] text-fuchsia-300/80">({r.kako_masked})</span>{r.me && <span className="ml-1 text-[9px] font-black text-lime-300">VOCÊ</span>}</p>
              <span className="shrink-0 text-right">
                <span className="block text-xs font-black text-amber-300" data-testid={`rp-top-coins-${r.pos}`}>🪙{fmt(r.coins)}</span>
                <span className="block text-[9px] text-purple-200/60">{r.chests} baú(s)</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RpTopWinners;
